// Shared constants for order tracking + source badges.
// Used everywhere in Nivo CRM.
// Badge style: pill, 6px radius, bg = color at 15% opacity, text = color at 100%.

export const ORDER_TRACKING = {
    nouveau:          { color: '#06B6D4', label: 'Nouveau' },
    call_1_message_1: { color: '#F59E0B', label: 'Call 1 / Message 1' },
    call_2_message_2: { color: '#F97316', label: 'Call 2 / Message 2' },
    call_3:           { color: '#EA580C', label: 'Call 3' },
    confirmed:        { color: '#10B981', label: 'Confirmé' },
    in_delivery:      { color: '#0D9488', label: 'In Delivery' },
    no_reply:         { color: '#EF4444', label: 'Sans Réponse' },
    returned:         { color: '#DC2626', label: 'Retourné' },
    fake:             { color: '#4B5563', label: 'Faux' },
};

export const SOURCE = {
    website:  { color: '#4B3FD8', label: 'Website' },
    whatsapp: { color: '#10B981', label: 'WhatsApp' },
};

// Helper to apply the 15%-bg / 100%-text badge style inline.
export const badgeStyle = (hex) => ({
    backgroundColor: hexWithAlpha(hex, 0.15),
    color: hex,
    borderRadius: '6px',
});

function hexWithAlpha(hex, alpha) {
    const h = hex.replace('#', '');
    const r = parseInt(h.substring(0, 2), 16);
    const g = parseInt(h.substring(2, 4), 16);
    const b = parseInt(h.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
